/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, shape, string, array, func, arrayOf, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Checkbox, FormControlLabel } from '@material-ui/core';
import ReactHTMLParser from 'react-html-parser';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useUIDSeed } from 'react-uid';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import Popover from '@material-ui/core/Popover';
import WrapUpModal from './WrapUpModal';
import { skuBuilder } from '../../../../pages/Checkout/containers/CheckoutFood/components/Partials/Helper/Helper';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import WrapUpHoverModal from './WrapUpHoverModal';

const styles = (theme) => ({
    rootPaper: {
        [theme.breakpoints.down('md')]: {
            margin: '8px 0',
        },
    },
    container: {
        width: '100%',
        maxWidth: '225px',
        [theme.breakpoints.down('md')]: {
            minHeight: '120px',
            margin: '2% 0',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            maxWidth: '90%',
        },
    },
    image: {
        width: '100%',
        height: 'auto',
        [theme.breakpoints.down('md')]: {
            width: '66px',
            margin: '0 15px 0 0',
        },
    },
    contentWrapper: {
        position: 'relative',
        padding: '20px 20px 0 20px',
        minHeight: '150px',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            height: 'auto',
            padding: 0,
            width: '100%',
            minHeight: 'auto',
        },
    },
    name: {
        marginBottom: '2px',
        fontSize: '18px',
        lineHeight: '21px',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            fontSize: '16px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    price: {
        fontSize: '14px',
    },
    radio: {
        position: 'absolute',
        bottom: '5px',
        left: '90px',
        [theme.breakpoints.down('md')]: {
            margin: 'auto',
            top: 0,
            right: '5px',
            bottom: 0,
            left: 'auto',
            height: '45px',
        },
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        fontWeight: '400',
        right: '72px',
        fontSize: '18px',
    },
    salePrice: {
        fontWeight: '400',
        right: '72px',
        fontSize: '18px',
        padding: '0 0 0 10px',
        color: theme.palette.pdp.salePrice || '#a1001a',
    },
    defaultPrice: {
        fontWeight: '400',
        right: '72px',
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    nameContainer: {
        display: 'flex',
    },
    title: {
        fontSize: '16px',
        backgroundColor: theme.palette.common?.white || '#fff',
        textDecoration: 'underline',
        border: '0',
        padding: 0,
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.common?.white || '#fff',
            outline: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    infoButton: {
        border: 'none',
        background: 'none',
        '&:hover, &:focus, &:active': {
            outline: 'none',
        },
    },
    iconContent: {
        width: 400,
        padding: 10,
    },
    root: {
        flexDirection: 'column-reverse',
        margin: '0',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'row-reverse',
            margin: '0 10px 0 15px',
            width: 'calc(100% - 20px)',
        },
    },
    label: {
        width: '100%',
    },
    infoIcon: {
        fill: theme.palette.cms?.primary || theme.palette.colorPrimary,
        [theme.breakpoints.down('sm')]: {
            width: '20px',
            height: '20px',
        },
    },
});

const WrapUpUI = ({
    classes, wrapupData, selectedItem, movieWrapupData, ssrDeviceType, isSelectedItemChecked,
}) => {
    const {
        skuPartNumber,
        sku,
    } = wrapupData;

    const [openModal, closeModal] = useState(false);
    function toggle() {
        closeModal(!openModal);
    }
    const [hover, isHover] = useState(false);
    function hoverData() {
        isHover(!hover);
    }
    const [info, setInfo] = useState('');
    const handleClick = (event) => {
        setInfo(event.currentTarget);
    };
    const handleClose = () => {
        setInfo('');
    };
    const seed = useUIDSeed();
    // Gets the value of sale price from the sku.
    const retailPrice = sku?.prices?.find((price) => price.type === 'retail')?.value;
    const salePrice = sku?.prices?.find((price) => price.type === 'sale')?.value;
    const defaultPrice = `$${sku?.prices?.[0]?.value}`;
    const nbcuMovie = movieWrapupData?.findContent?.content?.entries || [];
    const movieData = nbcuMovie.map((wrapup) => (wrapup.wrap_up));
    const movieSku = movieData[0]?.some((getsku) => skuBuilder(getsku?.sku) === skuBuilder(sku?.id) && getsku?.info_on_hover);
    const movieAddOnData = movieData[0]?.map((addonItem) => (
        skuBuilder(addonItem?.sku) === skuBuilder(sku?.id) && <ReactMarkdown key={`info-${sku?.id}`} source={addonItem?.info_on_hover} escapeHtml={false} />
    ));
    const wrapUpData = movieData[0]?.map((wrapupItem) => (
        skuBuilder(wrapupItem?.sku) === skuBuilder(sku?.id) && wrapupItem));
    const seeTitleData = wrapUpData?.some((seeTitle) => (seeTitle?.nbcu_see_titles));
    // If sku image does not exist, pick parent sku image.
    const onImageError = (e) => {
        const { parentProduct } = sku;
        if (parentProduct?.image) {
            const { image } = parentProduct;
            e.target.src = `${image.path}${image.name}z.jpg`;
        }
        return null;
    };

    return (
        <div>
            {(sku && sku.name && sku.image && sku.prices) ? (
                <Paper elevation={2} className={classes.rootPaper}>
                    <FormControlLabel
                        control={(
                            <Checkbox
                                id={`checkbox-${sku?.id}`}
                                data-testid={`checkbox-${sku?.id}`}
                                onClick={() => selectedItem(skuBuilder(skuPartNumber), sku)}
                            />
                        )}
                        checked={isSelectedItemChecked}
                        classes={{
                            root: classes.root,
                            label: classes.label,
                        }}
                        label={
                            (
                                <div className={classes.container}>
                                    <img
                                        className={classes.image}
                                        src={`${sku.image.path}${sku.image.name}z.jpg?width=225&height=247&auto=webp`}
                                        alt={sku.image.name}
                                        onError={(e) => onImageError(e)}
                                    />
                                    <div className={classes.contentWrapper}>
                                        <div className={classes.nameContainer}>
                                            <div className={classes.name}>{ReactHTMLParser(sku?.name)}</div>
                                            {ssrDeviceType === 'desktop'
                                                && (
                                                    movieSku
                                                    && (
                                                        <div className={classes.icon}>
                                                            <button type="button" onClick={handleClick} className={classes.infoButton} data-testid="info-button">
                                                                <InfoOutlinedIcon className={classes.infoIcon} />
                                                            </button>
                                                            <Popover
                                                                open={!!info}
                                                                anchorEl={info}
                                                                onClose={handleClose}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'center',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'center',
                                                                }}
                                                            >
                                                                <div className={classes.iconContent}>
                                                                    {movieAddOnData}
                                                                </div>
                                                            </Popover>
                                                        </div>
                                                    )
                                                )}
                                        </div>
                                        <div className={classes.price}>
                                            {salePrice && retailPrice && salePrice !== retailPrice
                                                ? (
                                                    <>
                                                        <s>
                                                            ${retailPrice}
                                                        </s>
                                                        <span className={classes.salePrice}>
                                                            SALE ${salePrice}
                                                        </span>

                                                    </>
                                                )
                                                : <span className={classes.defaultPrice}> {defaultPrice}</span>}

                                        </div>
                                        <div className={classes.seeTitle}>
                                            {seeTitleData && <button type="button" onClick={toggle} className={classes.title}> See titles</button>}
                                        </div>
                                    </div>
                                    {ssrDeviceType !== 'desktop' && (
                                        movieSku && (
                                            <button type="button" onClick={hoverData} className={classes.infoButton} data-testid="info-button">
                                                <InfoOutlinedIcon className={classes.infoIcon} />
                                            </button>
                                        )
                                    )}
                                </div>
                            )
                        }
                    />

                </Paper>
            ) : null}

            <div className={classes.addonWrapper}>
                {movieData[0]?.map((wrapupItem) => (
                    skuBuilder(wrapupItem?.sku) === skuBuilder(sku?.id)
                    && (
                        <React.Fragment key={seed(wrapupItem)}>
                            <WrapUpModal modalData={wrapupItem} closeModal={toggle} openModal={openModal} />
                            <WrapUpHoverModal modalData={wrapupItem} hoverModalClose={hoverData} hoverModalOpen={hover} />
                        </React.Fragment>
                    )
                ))}
            </div>
        </div>
    );
};

WrapUpUI.propTypes = {
    classes: object.isRequired,
    wrapupData: shape({
        skuPartNumber: string.isRequired,
        sku: shape({
            name: string.isRequired,
            image: shape({
                name: string.isRequired,
                path: string.isRequired,
            }).isRequired,
            prices: array.isRequired,
            id: string.isRequired,
        }),
    }).isRequired,
    selectedItem: func.isRequired,
    isSelectedItemChecked: bool.isRequired,
    ssrDeviceType: string.isRequired,
    movieWrapupData: shape({
        entries: arrayOf(shape({
            wrap_up: arrayOf(shape({
                nbcu_see_titles: string.isRequired,
            })),
        })),
    }),
};
WrapUpUI.defaultProps = {
    movieWrapupData: {},
};

const mapStateToProps = (state) => ({
    ssrDeviceType: getSSRDeviceType(state),

});
const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps),
);

export default enhance(WrapUpUI);
